import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="video-thumbnail"
export default class extends Controller {
  static targets = ["videoDropzone", "thumbnailField"]

  connect() {
    this.manuallyToggled = false
    this.setupVideoDropzoneListeners()
    this.checkVideoState()
    this.handleExistingVideo()
    // Initially hide thumbnail field when there's an existing video
    this.initializeVisibility()
  }

  toggle() {
    if (this.hasThumbnailFieldTarget) {
      const isVisible = this.thumbnailFieldTarget.style.display !== "none"
      if (isVisible) {
        this.manuallyToggled = false
        this.hideThumbnailField()
      } else {
        this.manuallyToggled = true
        this.showThumbnailField()
      }
    }
  }

  setupVideoDropzoneListeners() {
    // Find video dropzone by looking for the video_file preview element
    const videoPreview = this.element.querySelector('[data-form-param-name*="video_file"]')

    if (videoPreview) {
      // Find the dropzone element that's the next sibling
      this.videoDropzone = videoPreview.nextElementSibling?.querySelector('[data-controller*="dropzone"]')
    }

    if (!this.videoDropzone) {
      this.videoDropzone = this.element.querySelector('[data-controller*="dropzone"]')
    }

    if (this.videoDropzone) {

      // Use MutationObserver to watch for changes in multiple places
      const observer = new MutationObserver(() => {
        // Small delay to ensure DOM is updated
        setTimeout(() => {
          this.checkVideoState()
        }, 100)
      })

      // Watch the dropzone itself
      observer.observe(this.videoDropzone, {
        childList: true,
        subtree: true
      })

      // Also watch the preview container (where uploaded files are shown)
      if (videoPreview) {
        observer.observe(videoPreview, {
          childList: true,
          subtree: true
        })
      }

      // Watch the entire form for any changes
      observer.observe(this.element, {
        childList: true,
        subtree: true
      })

      // Also listen for direct dropzone events on the element
      this.videoDropzone.addEventListener('dragover', () => {
        setTimeout(() => this.checkVideoState(), 100)
      })

      this.videoDropzone.addEventListener('drop', () => {
        setTimeout(() => this.checkVideoState(), 500)
      })

      // Listen for click events (delete button)
      this.element.addEventListener('click', (event) => {
        if (event.target.closest('[data-form-file-field-label-outside-target="deleteButton"]')) {
          setTimeout(() => this.checkVideoState(), 100)
        }
      })
    }
  }

  checkVideoState() {
    if (this.hasThumbnailFieldTarget && this.videoDropzone) {
      // Check if there are any files in the video dropzone
      const previewElements = this.videoDropzone.querySelectorAll('.dz-preview')
      const otherPreviewElements = document.querySelectorAll('.c-form--file_field_label_outside-preview__file-container[data-video-file]')

      const hasFiles = previewElements.length > 0 || otherPreviewElements.length > 0

      if (hasFiles) {
        // Try to access the dropzone instance to get file info
        const dropzoneController = this.application.getControllerForElementAndIdentifier(this.videoDropzone, 'dropzone')
        let isVideoFile = true // default

        if (dropzoneController && dropzoneController.dropZone && dropzoneController.dropZone.files.length > 0) {
          const file = dropzoneController.dropZone.files[0]
          isVideoFile = file.type.startsWith('video/')
        } else {
          // Fallback: assume video if we can't determine
          isVideoFile = true
        }

        if (isVideoFile) {
          this.showThumbnailField()
        } else {
          this.hideThumbnailField()
        }
      } else {
        this.hideThumbnailField()
      }
    } else {
      this.hideThumbnailField()
    }
  }


  showThumbnailField() {
    if (this.hasThumbnailFieldTarget) {
      this.thumbnailFieldTarget.style.display = "block"
    }
  }

  hideThumbnailField() {
    if (this.hasThumbnailFieldTarget && !this.manuallyToggled) {
      this.thumbnailFieldTarget.style.display = "none"
    }
  }

  handleExistingVideo() {
    // Logic handled in initializeVisibility() method
  }

  initializeVisibility() {
    // For existing videos, hide thumbnail field by default
    if (this.hasThumbnailFieldTarget) {
      this.thumbnailFieldTarget.style.display = "none"
    }
  }
}
